import { Route,Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import BhagavadGitaChapter from './AllChapters';
import Chapter from './Chapter';
import GetAllVerses from './GetAllVerses';
import VerseDetails from './VerseDetails';

function App() {

  return(
    <div className="App">
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/about' element={<About/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/chapters' element={<BhagavadGitaChapter/>}/>
        <Route path='/chapter/:id' element={<Chapter/>}/>
        <Route path='/chapter/:id/verses' element={<GetAllVerses/>}/>
        <Route path='/chapters/:chapter_id/verses/:id' element={<VerseDetails/>}/>
      </Routes>
    </div>
  )
}

export default App;
